import { stringify } from "querystring";
import { ReactNode, useCallback } from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import Stream, { StreamMessage } from "./Stream";
import Notification from "./Notification";

export enum Status {
  NOTHING,
  LOADING,
  LOADED,
  ERROR,
}

export default interface Session {
    status: Status,
    error_reason: string,
    cookie: {
        name: string,
        value: string,
    }
    email: string,
    brand: string,
    brand_name: string,
    is_admin: boolean,
    onboarding: boolean,
    is_onboarded: boolean,
    settings: any,
    notifications: Notification[],
}

const Context = createContext<Session>({
  status: Status.NOTHING,
  error_reason: "",
  cookie: {
    name: "",
    value: "",
  },
  email: "",
  brand: "",
  brand_name: "",
  is_admin: false,
  onboarding: false,
  is_onboarded: false,
  settings: {},
  notifications: [],
});

interface SessionProviderProps {
  children: ReactNode;
  cookie_name: string;
}

let doOnce = 0;

export function SessionProvider({
  children,
  cookie_name = "issuer_session",
}: SessionProviderProps) {
  const [cookies] = useCookies([cookie_name]);

  const [session, setSession] = useState<Session>({
    status: Status.LOADING,
    error_reason: "",
    cookie: {
      name: cookie_name,
      value: cookies[cookie_name],
    },
    email: "",
    brand: "",
    brand_name: "",
    is_admin: false,
    onboarding: false,
    is_onboarded: false,
    settings: {},
    notifications: [],
  });

    const [stream, setStream] = useState<Stream<StreamMessage>>();
    useEffect(() => {
        // check, if there is any session
        if(doOnce === 0 && cookies[cookie_name]) {
            doOnce = 1
            let actualSession = {
                status: Status.LOADING,
                error_reason: "",
                cookie: {
                    name: cookie_name,
                    value: cookies[cookie_name],
                },
                email: "",
                brand: "",
                brand_name: "",
                is_admin: false,
                onboarding: false,
                is_onboarded: false,
                settings: {},
                notifications: [] as Notification[],
            }
            /*
            setSession(actualSession)
            */
            // get session information
            fetch('/api/v1/user?type=settings').then(resp => resp.json()).then((obj) => {
                if(obj.success) {
                    // get notifications
                    const metadata = obj.response;
                    fetch('/api/v1/user?type=notifications').then(resp => resp.json()).then((notifications) => {
                        if(notifications.success) {
                            let newNotification: Notification[] = [];
                            // notifications.response contains array of correctly ordered notification objects
                            notifications.response.forEach((notification: any) => {
                                newNotification.push(new Notification(notification.id, notification))
                            })
                            actualSession = {
                                status: Status.LOADED,
                                cookie: {
                                    name: cookie_name,
                                    value: cookies[cookie_name],
                                },
                                error_reason: "",
                                email: metadata.email,
                                brand: metadata.brand,
                                brand_name: metadata.brand_name,
                                is_admin: metadata.is_admin,
                                onboarding: metadata.onboarding,
                                is_onboarded: metadata.is_onboarded,
                                settings: metadata.settings,
                                notifications: newNotification,
                            }
                            setSession(actualSession)
                            // connect to the stream
                            if(stream) {
                                stream.close();
                            }
                            setStream(new Stream('/api/v1/user?type=stream', (message: StreamMessage) => {
                                let newSession = {...actualSession};
                             
                                if(message.type === 'deleted') {
                                    newSession.notifications = newSession.notifications.filter((n) => n.id !== message.id)
                                } else if(message.type === 'added') {
                                    let ns = [...newSession.notifications]
                                    ns.unshift(new Notification(message.id, message.notification))
                                    newSession.notifications = ns;
                                }
                                actualSession = newSession;
                                setSession(newSession);
                            }))
                            doOnce = 0
                        } else {
                            throw notifications.error
                        }
                    })
                } else {
                    throw obj.error;
                }
            }).catch((reason: any) => {
                setSession({
                    status: Status.ERROR,
                    error_reason: reason,
                    cookie: {
                      name: cookie_name,
                      value: cookies[cookie_name],
                    },
                    email: "",
                    brand: "",
                    brand_name: "",
                    is_admin: false,
                    onboarding: false,
                    is_onboarded: false,
                    settings: {},
                    notifications: [],
                })
                window.location.href = "/auth/logout"
                doOnce = 0
            })
        } else if(!cookies[cookie_name]) {
            setSession({
                status: Status.NOTHING,
                error_reason: "no session",
                cookie: {
                  name: cookie_name,
                  value: cookies[cookie_name],
                },
                email: "",
                brand: "",
                brand_name: "",
                is_admin: false,
                onboarding: false,
                is_onboarded: false,
                settings: {},
                notifications: [],
            })
        }
    }, [])

  return <Context.Provider value={session}>{children}</Context.Provider>;
}

export const useSession = () => useContext(Context);
